import React from 'react';
import { ProgressModal } from '../../../components/modal';
import type { RecordingMode } from '../../media/hooks/use-video-export';

type ExportOverlayProps = {
  progress: number; // 0–1
  onCancel: () => void;
  recordingMode?: RecordingMode;
};

export const ExportOverlay: React.FC<ExportOverlayProps> = ({ progress, onCancel, recordingMode }) => (
  <ProgressModal
    open
    title={recordingMode === 'save' ? 'Guardando video' : 'Exportando video'}
    // Media and codecs warm up before the first frame exists, and that can take a while.
    subtitle={progress === 0 ? 'Preparando la pieza…' : undefined}
    percent={Math.round(progress * 100)}
    cancelLabel='Cancelar'
    onCancel={onCancel}
  />
);
